import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { ConfigBuildComponent } from './config-build/config-build.component';
import { ConfigBuildHomeComponent } from './config-build-home/config-build-home.component';


// Define the routes
const routes: Routes = [
  {
    path: '',
    component: ConfigBuildComponent,
    children: [
      {
        path: '',
        component: ConfigBuildHomeComponent,
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  declarations: [
ConfigBuildComponent,
ConfigBuildHomeComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    FormsModule,

    
  ]
})
export class ConfigBuildModule {}
